var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 4.30701C9.66491 4.30742 8.35699 4.66939 7.21345 5.35437C6.06991 6.03934 5.13358 7.02166 4.50417 8.1967C3.87476 9.37174 3.57587 10.6955 3.63931 12.027C3.70275 13.3585 4.12615 14.6478 4.86443 15.7577L3.62866 19.0455L7.76678 18.2972C8.76322 18.7842 9.85673 19.0399 10.9658 19.0454C12.0748 19.0509 13.1708 18.806 14.172 18.329C15.1732 17.8519 16.0539 17.155 16.7483 16.2903C17.4427 15.4255 17.9329 14.4152 18.1825 13.3346C18.432 12.254 18.4345 11.131 18.1896 10.0493C17.9448 8.96759 17.459 7.95511 16.7684 7.08733C16.0777 6.21954 15.2001 5.51884 14.201 5.03744C13.2019 4.55603 12.107 4.30635 10.9979 4.30701Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29736 9.97562C9.29736 9.63928 9.3971 9.31048 9.58397 9.03082C9.77083 8.75116 10.0364 8.53319 10.3472 8.40448C10.6579 8.27576 10.9998 8.24208 11.3297 8.3077C11.6596 8.37332 11.9626 8.53528 12.2005 8.77312C12.4383 9.01095 12.6003 9.31397 12.6659 9.64385C12.7315 9.97374 12.6978 10.3157 12.5691 10.6264C12.4404 10.9372 12.2224 11.2028 11.9428 11.3896C11.6631 11.5765 11.3343 11.6762 10.998 11.6762V12.81",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 15.6444C10.8437 15.6444 10.7168 15.5174 10.7168 15.361C10.7168 15.2044 10.8437 15.0775 11.0002 15.0775",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.6445C11.1565 15.6445 11.2834 15.5176 11.2834 15.3611C11.2834 15.2045 11.1565 15.0776 11 15.0776",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.ab61b39b53973cec1e7e27409219ca9b.svg";
export { ForwardRef as ReactComponent };